"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonMedia = require("@mmc/common-media");
var _reactScrollTrigger = _interopRequireDefault(require("react-scroll-trigger"));
var _text = require("@mmc/text");
var _highLow = _interopRequireDefault(require("../../styles/layouts/high-low.css"));
var _cardContent = _interopRequireDefault(require("../card-content"));
var _editorialCards = _interopRequireDefault(require("../editorial-cards.props/editorial-cards.defaultProps"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var HighLow = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(HighLow, _React$Component);
  function HighLow(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      inView: false
    };
    _this.onProgressViewport = _this.onProgressViewport.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = HighLow.prototype;
  _proto.onProgressViewport = function onProgressViewport(scrollInfo) {
    var inView = this.state.inView;
    if (scrollInfo.progress > 0.2 && inView === false) {
      // eslint-disable-line
      this.setState(function () {
        return {
          inView: true
        };
      });
    }
  };
  _proto.hasVideoPath = function hasVideoPath(videoPath) {
    return videoPath !== ' ' && videoPath !== '' && videoPath !== undefined && videoPath !== null;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      theme = _this$props.theme,
      columns = _this$props.columns,
      editorialLayout = _this$props.editorialLayout,
      disclaimerData = _this$props.disclaimerData,
      addPriceDisclaimer = _this$props.addPriceDisclaimer,
      priceDisclaimerId = _this$props.priceDisclaimerId;
    var inView = this.state.inView;
    return /*#__PURE__*/_react["default"].createElement(_reactScrollTrigger["default"], {
      throttleScroll: 50,
      onProgress: this.onProgressViewport
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _highLow["default"].wrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-lg-1']
    }), columns && columns.map(function (column, i) {
      // check if it should be high or low
      var videoPath = handleNestedProp(column, 'column.video.source');
      var hasVideo = _this2.hasVideoPath(videoPath);
      /* eslint-disable */
      if (i % 2 === 0) {
        /* eslint-enable */
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: i,
          className: "\n                " + theme['col-xs-12'] + "\n                " + theme['col-sm-7'] + "\n                " + theme['col-lg-6'] + "\n                " + (inView ? _highLow["default"].animationLeft : '') + "\n                " + _highLow["default"].animateAbleCard + "\n                " + _highLow["default"].topSection + "\n                "
        }, /*#__PURE__*/_react["default"].createElement(_commonMedia.CommonMedia, {
          theme: theme,
          mediaClasses: hasVideo ? [] : [_highLow["default"].image, theme.marginBottom40],
          containerClasses: hasVideo ? [theme.marginBottom40] : [],
          size: 1080,
          image: column.image,
          video: column.video,
          sizes: "(min-width: 768px) 70vw, 100vw",
          hideVideoOnMobile: column.hideVideoOnMobile,
          aspectRatio: hasVideo ? '4:3' : null
        }), /*#__PURE__*/_react["default"].createElement(_cardContent["default"], {
          theme: theme,
          content: column,
          editorialLayout: editorialLayout,
          cardType: "high",
          disclaimerData: disclaimerData,
          addPriceDisclaimer: addPriceDisclaimer,
          priceDisclaimerId: priceDisclaimerId
        }));
      }
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: i
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + theme['col-sm-1']
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "\n                " + theme['col-xs-12'] + "\n                " + theme['col-sm-4'] + "\n                " + theme['col-lg-3'] + "\n                " + _highLow["default"].low + "\n                " + _highLow["default"].animateAbleCard + "\n                " + (inView ? _highLow["default"].animationRight : '') + "\n                "
      }, /*#__PURE__*/_react["default"].createElement(_commonMedia.CommonMedia, {
        theme: theme,
        mediaClasses: hasVideo ? [] : [_highLow["default"].image, theme.marginBottom40],
        containerClasses: hasVideo ? [theme.marginBottom40] : [],
        size: 480,
        image: column.image,
        video: column.video,
        sizes: "(min-width: 768px) 40vw, 100vw",
        aspectRatio: hasVideo ? '3:4' : null
      }), /*#__PURE__*/_react["default"].createElement(_cardContent["default"], {
        theme: theme,
        content: column,
        editorialLayout: editorialLayout,
        cardType: "low",
        disclaimerData: disclaimerData,
        addPriceDisclaimer: addPriceDisclaimer,
        priceDisclaimerId: priceDisclaimerId
      })));
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme['col-lg-1']
    }))));
  };
  return HighLow;
}(_react["default"].Component);
exports["default"] = HighLow;
HighLow.displayName = 'HighLow';
HighLow.defaultProps = {
  columns: _editorialCards["default"].columns
};